import Checkbox from '@mui/material/Checkbox';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useState } from 'react';
import {
  GridRenderCellParams,
  GridRenderEditCellParams,
  useGridApiContext,
} from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import { functionalityType } from './DataGridUserRightPanel';

export function EditCellCheckbox({
  params,
  handleSingleDeleteDialogOpen,
}: {
  params: GridRenderEditCellParams;
  handleSingleDeleteDialogOpen: CallableFunction;
}) {
  const { id, field } = params;
  const [checked, setChecked] = useState<boolean | null>(params.value);
  const apiRef = useGridApiContext();

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setChecked(value);
    apiRef.current.setEditCellValue({ id, field, value });
  };

  //if checked === null at component mounting this means that there is no right defined for this field, so const functionalityRightId will be undefined
  if (checked === null) {
    return <Checkbox checked={false} onChange={handleCheckBoxChange} />;
  }

  const functionalityRightId = params.row.functionalities?.find(
    (functionality: functionalityType) => functionality.name === field
  )?.functionalityRightId;

  return (
    // functionalityRightId is undefined, this mean that user have no right defined for this field still, so we dont want to display the reset button
    <Box>
      <Checkbox
        checked={checked}
        onChange={handleCheckBoxChange}
        {...(checked === false && { icon: <CheckBoxIcon sx={{ color: '#d12d38' }} /> })}
      />
      {functionalityRightId && (
        <Button
          variant="outlined"
          onClick={(event) => {
            // without stopPropagation the stopCellEditMode wont work
            event.stopPropagation();
            handleSingleDeleteDialogOpen(id, functionalityRightId);
          }}
        >
          Reset
        </Button>
      )}
    </Box>
  );
}

export function ViewCellCheckbox({ params }: { params: GridRenderCellParams }) {
  const { value } = params;

  if (value === null) {
    return <Checkbox sx={{ opacity: 0.75 }} disabled />;
  }

  return (
    <Box sx={{ opacity: 0.75 }}>
      <Checkbox
        checked={value}
        disabled
        {...(value === false && { icon: <CheckBoxIcon sx={{ color: '#d12d38' }} /> })}
      />
      <Button variant="outlined" disabled>
        Reset
      </Button>
    </Box>
  );
}
